/** Shared deliveries list page size (POS `start`/`size` → BOP). Keep free of store imports. */
export const DELIVERIES_PAGE_SIZE = 200;
